module.exports = __webpack_public_path__ + "media/images/lp/img_merit_01-b562776ad9d94f9277013ecfbb48fc0d.png";